var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgFolderIcon = function SvgFolderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 19h17V9h-7.586a3 3 0 01-2.121-.879L8.672 6H3.5v13zm-2-14v15a1 1 0 001 1h19a1 1 0 001-1V8a1 1 0 00-1-1h-8.586a1 1 0 01-.707-.293L9.793 4.293A1 1 0 009.086 4H2.5a1 1 0 00-1 1z",
    fill: "#9CA6AD"
  })));
};

export default SvgFolderIcon;